// Which image to show for a persona.
//
// Preferred: the generated avatar (CustomerPersona.avatar_s3_key, served as a presigned
// `avatar_url`). It is absent when generation has not run yet or failed, so the bundled
// stock set stays as a permanent fallback rather than a transient one.
//
// The fallback is keyed on the persona id, not its position in the list. It used to use
// the list index, which meant a persona's face changed when the list was sorted or paged
// (#93) — a trainee could not recognise a customer they had practised with.

const STOCK_AVATAR_COUNT = 34;

/** Stable non-cryptographic hash of a string → non-negative integer. */
const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const stockAvatarPath = (persona) => {
  const id = String(persona?.id ?? "");
  const index = (id ? hashString(id) % STOCK_AVATAR_COUNT : 0) + 1;
  const padded = String(index).padStart(3, "0");
  const dir = persona?.gender === "MALE" ? "men" : "women";
  return `/avatars/${dir}/${padded}.jpg`;
};

export const personaAvatarUrl = (persona) =>
  persona?.avatar_url || stockAvatarPath(persona);

// The photoreal in-store scene. Absent until generated, and generation can fail, so the
// caller must fall back to the avatar rather than assume this exists.
export const personaSceneUrl = (persona) => persona?.situation_url || null;

/**
 * What to show as a card's main image, and whether the avatar still needs its own slot.
 *
 * Fallback chain is scene -> avatar -> bundled stock image. When the scene is present the
 * avatar moves to a small inset, so the two images are never shown at the same size.
 */
export const personaCardImages = (persona) => {
  const scene = personaSceneUrl(persona);
  const avatar = personaAvatarUrl(persona);
  return scene
    ? { hero: scene, inset: avatar, hasScene: true }
    : { hero: avatar, inset: null, hasScene: false };
};
